import { render, staticRenderFns } from "./CbsReferencePicker.vue?vue&type=template&id=0de85738&scoped=true"
import script from "./CbsReferencePicker.vue?vue&type=script&lang=js"
export * from "./CbsReferencePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de85738",
  null
  
)

export default component.exports